/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO pro vytvoření daňového přiznání z nemovitých věcí ve formátu DNEDP6
 */
export interface TaxReturnDto { 
    /**
     * Kód druhu pozemku pro náhradní zobrazení PZE parcel
     */
    alternativePzeDrupozKod: number;
    /**
     * E-mail sestavující osoby
     */
    assemblerEmail?: string;
    /**
     * Křestní jméno sestavující osoby
     */
    assemblerFirstname?: string;
    /**
     * Telefon sestavující osoby
     */
    assemblerPhone?: string;
    /**
     * Příjmení sestavující osoby
     */
    assemblerSurname?: string;
    /**
     * Titul sestavující osoby
     */
    assemblerTitle?: string;
    /**
     * Křestní jméno osoby oprávněné k podpisu
     */
    authorizedSignerFirstname?: string;
    /**
     * Vztah k právnické osobě (funkce osoby oprávněné k podpisu)
     */
    authorizedSignerPosition?: string;
    /**
     * Příjmení osoby oprávněné k podpisu
     */
    authorizedSignerSurname?: string;
    /**
     * Pokud je nastaveno na true, bude sestaveno daňové přiznání i z dat budov z aplikace. Pak není možné přidat ručně soubor s budovami.
     */
    generateBuildingsFromAppData?: boolean;
    /**
     * Zahrnout ostatní dotčené osoby do přiznání
     */
    includeOtherConcerned?: boolean;
    /**
     * Zahrnout parcely z nákupních případů na přelomu roku
     */
    includePurchaseCase?: boolean;
    /**
     * Zahrnout parcely ze zjednodušené evidence (PZE)
     */
    includePze?: boolean;
    /**
     * Zahrnout společné jmění manželů (SJM)
     */
    includeSjm?: boolean;
    /**
     * Příznak pro provozování zemědělské a rybářské výroby (osvobození)
     */
    operateAgriAndFishProduction?: boolean;
    /**
     * ID kraje pro daňové přiznání (tax_return_region.id)
     */
    regionId: number;
    /**
     * ID dotčené osoby (subject_contact.id)
     */
    subjectId: number;
    /**
     * Kód finančního úřadu (ufo)
     */
    taxOffice?: number;
    /**
     * Kód územního pracoviště (pracufo)
     */
    taxWorkplace?: number;
    /**
     * Použít propachtovanou výměru místo katastrální
     */
    useRentedAcreage?: boolean;
    /**
     * Rok, za který se daňové přiznání podává
     */
    year: number;
}

